import script from "./People.vue?vue&type=script&lang=ts&setup=true"
export * from "./People.vue?vue&type=script&lang=ts&setup=true"

import "./People.vue?vue&type=style&index=0&id=aecc25f4&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aecc25f4"]])

export default __exports__